<template>
  <div v-if="ready">
    <img src="@/assets/img/datitop.png" width="100%" alt="" />
    <div style="padding: 0.24rem;position: relative">
      <video controls style="width: 100%" :src="video.videoUrl"></video>
      <!-- <iframe height=498 width=510 src='https://player.youku.com/embed/XNTEzNDAwNDk0OA==' frameborder=0 'allowfullscreen'></iframe> -->
      <div class="innerbox">
        <!-- <img style="width: 0.9rem;margin: 0 auto" src="@/assets/img/play.png" alt=""> -->
        <!-- <div style="font-size: 0.32rem;margin-top: 0.1rem;color: #fff">02:55</div> -->
      </div>
    </div>

    <div class="timu">
      <div class="question_title">
        一、单选题【共{{ count }}题】
      </div>
      <div class="question_desin">{{ tnum }}.{{ timu.name }}</div>
      <RadioGroup
        v-model="answer"
        style="margin-top: 0.5rem; font-size: 5rem"
        @change="radiochange"
      >
        <CellGroup>
          <Cell size="large">
            <Radio
              name="A"
              ><span class="sp">A.{{ timu.Axuan }}</span></Radio
            >
          </Cell>
          <Cell size="">
            <Radio
              name="B"
              ><span class="sp">B.{{ timu.Bxuan }}</span></Radio
            >
          </Cell>
          <Cell size="">
            <Radio
              name="C"
              ><span class="sp">C.{{ timu.Cxuan }}</span></Radio
            >
          </Cell>
          <Cell size="large">
            <Radio
              name="D"
              ><span class="sp">D.{{ timu.Dxuan }}</span></Radio
            >
          </Cell>
        </CellGroup>
      </RadioGroup>
      <div style="padding: 0.3rem" :class="result?'success':'error'" v-if="submitAanswer">
        {{ result ? "正确" : "错误" }}，正确答案为{{ timu.daan }}
      </div>
    </div>
    <div style="margin: 0 0.3rem; margin-top: 0.1rem">
      <Button
        :disabled="!!submitAanswer"
        color="#D7463A"
        round
        size="large"
        @click="dati"
        >确定</Button
      >
      <Button
        v-if="count  !==  tnum"
        round
        size="large"
        style="margin-top: 0.2rem; color: #d7463a; background-color: #fcebeb"
        @click="next"
        >下一题</Button
      >
    </div>
    <div style="height: 1rem"></div>
    <Overlay :show="show">
      <div class="innerbox">
        <img
          width="50%"
          src="@/assets/img/top.png"
          alt=""
          style="margin-left: 25%;display: block"
        />
        <div class="jifen">
          恭喜获得<span class="number">{{ getpoint }}</span
          >积分
        </div>
        <div class="jifen" @click="$router.replace({ path: '/' })">
          返回首页
        </div>
        <img
          class="close"
          src="@/assets/img/close.png"
          alt=""
          @click="show = false"
        />
      </div>
    </Overlay>
  </div>
</template>

<script>
import { RadioGroup, Radio, CellGroup, Cell, Button, Overlay } from "vant";
import { videoDetail, nextquestion } from "@api/answer";
export default {
  components: { RadioGroup, Radio, CellGroup, Cell, Button, Overlay },
  data() {
    return {
      show: false,
      ready: false,
      answer: "",
      count: "", //题目数量
      list: [], //题目列表
      timu: {}, //当前题目
      submitAanswer: "",
      getpoint: 0,
      video: null,
      tnum:1
    };
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    } else {
      this.$dialog.error("url没有传id");
    }
    this.getdata();
  },
  computed: {
    result() {
      return this.timu.daan == this.submitAanswer ? true : false;
    },
  },
  methods: {
    getdata() {
      videoDetail({ id: this.id }).then((res) => {
        console.log(res);
          this.tnum = res.data.nums;
          this.timu = res.data.test;
          this.count = res.data.count;
          this.point = res.data.point;
          this.ready = true;
          this.video = res.data.video;
      }).catch((err) => {
        this.ready = true;
      });
    },
    radiochange(e) {
      // this.answer = "A"
      if (this.submitAanswer) {
        this.answer = this.submitAanswer;
      }
    },
    next() {
      this.answer = "";
      this.submitAanswer = "";
      this.getdata();
    },
    dati() {
      if (this.answer == "") {
        this.$dialog.error("请先选择答案");
      } else {
        nextquestion({
          did: this.timu.id,
          vid: this.video.id,
          nums: this.tnum*1 +1,
          answer: this.answer
        }).then((res) => {
          console.log(res)
          this.submitAanswer = this.answer;
          if (res.data.is == 1 && res.data.isGtepoint !==1) {
            this.show = true;
            this.getpoint = res.data.score;
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.timu {
  padding: 0.3rem;
}
.timu .question_title {
  font-size: 0.32rem;
  line-height: 0.6rem;
}
.timu .question_desin {
  margin-top: 0.3rem;
  font-size: 0.3rem;
  line-height: 0.46rem;
}
.van-radio {
  font-size: 0.3rem;
  padding: 0.15rem;
}
.van-nav-bar .van-icon {
  color: #333333;
  font-size: 0.4rem;
}
.active .sp {
  color: #d6473b;
}

.innerbox {
  width: 80%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.jifen {
  margin-left: 10%;
  width: 80%;
  background-image: url("~@/assets/img/bot.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  text-align: center;
  line-height: 0.9rem;
  font-size: 0.5rem;
  font-weight: normal;
  font-size: 0.4rem;
  margin-top: 0.4rem;
}
.close {
  position: absolute;
  top: -0.8rem;
  right: 0;
  height: 0.8rem;
}
.bottom {
  height: 1rem;
  line-height: 1rem;
  position: fixed;
  width: 100%;
  text-align: center;
  bottom: 0;
  font-size: 0.4rem;
  color: #ffffff;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 99;
}
.innerbox{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  text-align: center;
  z-index: 111;
}
.success{
  color: #1989fa;
}
.error{
  color: red;
}
</style>